import { Field, Input, MediaInput } from '@zendeskgarden/react-forms'
import type { ZenInputProps } from './interface'
import { InputContainer, MediaInputWrapper } from './style'

export function ZenInput({
  label,
  value,
  defaultValue,
  placeholder,
  disabled,
  start,
  end,
  type = 'text',
  onChange,
}: ZenInputProps) {
  const sharedProps = {
    value,
    defaultValue,
    placeholder,
    disabled,
    type,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => onChange?.(e.target.value),
  }

  return (
    <InputContainer>
      {label && <Field.Label>{label}</Field.Label>}
      {start || end ? (
        <MediaInputWrapper>
          <MediaInput start={start} end={end} {...sharedProps} />
        </MediaInputWrapper>
      ) : (
        <Input {...sharedProps} />
      )}
    </InputContainer>
  )
}
